import React from 'react';
import PropTypes from 'prop-types';
import { Row, Modal, Button, Form } from 'react-bootstrap';
const uuid = require('uuid');

const OrganizationActions = require('../../actions/OrganizationActions');
const OrganizationStore = require('../../stores/OrganizationStore');
const ForgeError = require('../../util/error');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    orgId: PropTypes.number.isRequired,
    className: PropTypes.string
};

const defaultProps = {
    className: ''
};

class OrgAccountInfoEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            organizationStoreState: OrganizationStore.getState(),
            displayName: null,
            email: null,
            password: null,
            updateInfoActionId: null,
            saveEnabled: false,
            error: null
        };

        this.onDisplayNameChange = this.onDisplayNameChange.bind(this);
        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.saveHandler = this.saveHandler.bind(this);
        this.unsubscribes = [OrganizationStore.listen(this.onOrganizationStoreStateChange.bind(this))]
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onOrganizationStoreStateChange(newState) {
        let additionalState = {};

        if (newState.action.id === this.state.updateInfoActionId ) {
            additionalState = {
                ...additionalState,
                updateInfoActionId: null,
                displayName: null,
                saveEnabled: !!newState.action.error, //disable save on successful action completion
                error: newState.action.error
            };
        }

        this.setState({ organizationStoreState: newState, ...additionalState });
    }

    onDisplayNameChange(e) {
        this.setState({ displayName: e.target.value, saveEnabled: true });
    }

    onPasswordChange(e) {
        this.setState({ password: e.target.value, saveEnabled: true });
    }

    onEmailChange(e) {
        return; // TODO: enable
        // this.setState({ email: e.target.value, saveEnabled: true });
    }

    saveHandler() {
        if (typeof this.state.password == 'string' && this.state.password.length < 8 ) {
            this.setState({ error: new ForgeError({ message: "Password must be 8+ characters" })});
            return;
        }

        if (typeof this.state.displayName == 'string' && this.state.displayName.length === 0 ) {
            this.setState({ error: new ForgeError({ message: "Please fill in the missing field" })});
            return;
        }

        const actionId = uuid.v4();
        this.setState({ updateInfoActionId: actionId }, () => {
            OrganizationActions.updateOrgInfo(actionId, {
                orgId: this.props.orgId,
                displayName: this.state.displayName,
                password: this.state.password
            });
        });
    }

    render() {
        const orgInfo = this.state.organizationStoreState.organizations[this.props.orgId];

        if (!orgInfo) {
            return null;
        }

        return (
            <Row className={`${this.props.className}`}>
                <div className="col-12 user-info-col">
                    <h2>Account Information</h2>
                    <hr/>
                    <ErrorBox error={this.state.error} />

                    <Form.Group controlId="settings-last-name">
                        <Form.Label>display name</Form.Label>
                        <Form.Control
                            type="text"
                            aria-label="display name"
                            value={typeof this.state.displayName === 'string' ? this.state.displayName : orgInfo.display_name}
                            onChange={this.onDisplayNameChange}
                        />
                    </Form.Group>

                    <Form.Group controlId="settings-password">
                        <Form.Label>password</Form.Label>
                        <Form.Control
                            type="password"
                            aria-label="password"
                            value={typeof this.state.password === 'string' ? this.state.password : 'filler12'}
                            onChange={this.onPasswordChange}
                        />
                    </Form.Group>

                    <Form.Group controlId="settings-email">
                        <Form.Label>email</Form.Label>
                        <Form.Control
                            type="email"
                            disabled
                            aria-label="email"
                            value={typeof this.state.email === 'string' ? this.state.email : orgInfo.email}
                            onChange={this.onEmailChange}
                        />
                    </Form.Group>
                </div>
                <div className="col-12">
                    <Button
                        disabled={!this.state.saveEnabled || !!this.state.updateInfoActionId}
                        onClick={this.saveHandler}
                    >
                        save changes
                    </Button>
                </div>
            </Row>
        );
    }
}

OrgAccountInfoEdit.propTypes = propTypes;
OrgAccountInfoEdit.defaultProps = defaultProps;

export default OrgAccountInfoEdit;